import { createContext, useContext, useEffect } from 'react';

export type GeneralSettingsSectionKey = 'generalSettings' | 'invoiceTemplate' | 'emailTemplate';

type SetDirty = (section: GeneralSettingsSectionKey, isDirty: boolean) => void;

const GeneralSettingsDirtyContext = createContext<SetDirty | null>(null);

export const GeneralSettingsDirtyProvider = GeneralSettingsDirtyContext.Provider;

export function useSyncDirty(section: GeneralSettingsSectionKey, isDirty: boolean) {
    const setDirty = useContext(GeneralSettingsDirtyContext);
    useEffect(() => {
        setDirty?.(section, isDirty);
    }, [isDirty, section, setDirty]);
}
